import React, { useEffect, useState } from 'react';
import { Container, Row, Toast, Modal, Alert, Tab, Tabs, Col } from 'react-bootstrap';
import api from '../../seller-apis/api';
import {negotiationReq,
  filterOrdersfilter,
  orderRevoke,
  filterOrders
} from '../../seller-apis/apidataField';
import PaginationCom from '../common/Pagination';
import ConfirmationModal from '../common/ConfirmationModal';
import Popup from '../common/Popup';

import TrackOrderPopup from '../common/TrackOrder-Popup';
import '../order.css';
import OrderCardWeb from '../common/OrderCardWeb';
import { useAlert } from 'react-alert';
import { useOrderDateAlert, resetOrderDateFilter, resolveOrderDateRange, REVOKED_ORDER_DATE_DAYS } from './useOrderDateAlert';
import ProductSearch from '../common/ProductSearch';
import { useDispatch, useSelector } from 'react-redux';
import { Actions } from '../../Actions/Actions';
import MainLoader from '../common/Loader/PageLoader';
import OrderSKUSearch from '../common/ProductSearch/OrderSKUSearch';
import moment from 'moment';

var dateFromWeb;
var dateToWeb;
var datesWeb;

// Updated globalFilter to match your API structure
var globalFilter = {
    "pageNo": 1,
    "size": 10,
    "filter": {
        "reverseOrder": "Yes"
        // Based on your API response, it looks like we need to check for reverseData existence
        // You might need to adjust this based on your backend API
    },
    "sortFilter": {
        "ticketId": -1
    }
};

function ReverseOrders() {
  const dispatch = useDispatch();
  var outerdiv;
  var loaderDiv;
  const alert = useAlert()
  const showOrderDateAlert = useOrderDateAlert(alert)
  const [revokedOrd, setrevokedOrd] = useState([]);
  const [newOrdersList, setnewOrdersList] = useState([]);
  const [orderHistoryList, setorderHistoryList] = useState([]);
  const [ennewloader, setennewloader] = useState("block");
  const [negotiationRequests, setnegotiationRequests] = useState([]);
  const [newRecords, setnewRecords] = useState();
  const [negotRecords, setnegotRecords] = useState();

  const [selectedOrder, setSelectedOrder] = useState();

  // Web states
  const [allOrders, setallOrders] = useState([]);
  const [allRecords, setallRecords] = useState(1);
  const [webFiltCurr, setwebFiltCurr] = useState();
  const [speechRes, setspeechRes] = useState();

  // Pagination related
  const [selectedPage, setSelectedPage] = useState(1);
  const [sortHistdatefrom, setHistsortdatefrom] = useState();
  const [sortHistdateto, setHistsortdateto] = useState();

  // Confirmation related
  const [confirmationState, setconfirmationState] = useState(false)
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [confirmationFor, setconfirmationFor] = useState();
  const [negotiateState, setnegotiateState] = useState();
  const [confirmationType, setconfirmationType] = useState();
  const [selectedOrdername, setSelectedOrdername] = useState();
  
  // Toast
  const [showToast, setshowToast] = useState(false)
  const [compforPaginationweb, setcompforPaginationweb] = useState("allOrdersWeb");

  // Track order Popup
  const [selectedtrackOrder, setselectedtrackOrder] = useState(0);
  const [selectedTrackwithin, setselectedTrackwithin] = useState(0)
  const [originalOrders, setOriginalOrders] = useState([]);

  //Product Detail Popup
  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [defUrl, setdefUrl] = useState();

  // Web filter related states
  const [addressName, setAddressName] = useState("")
  const [orderId, setOrderId] = useState();
  const [orderName, setorderName] = useState();
  const [isPopupTrackVisWeb, setisPopupTrackVisWeb] = useState("none");
  const [selectedtrackOrderWeb, setselectedtrackOrderWeb] = useState(0);
  const [detailPPrice, setdetailPPrice] = useState("");
  const [minValDate, setMinValDate] = useState("");
  const [searchType, setSearchType] = useState("Product Name");
  const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")
  
  //<Start-Here> Track button Issue | Ticket : SL-950
  const [selectedTransitDetail, setSelectedTransitDetail] = useState([]);
  const [selectedPopupId, setSelectedPopupId] = useState(null);

  useEffect(() => {
    setOrderId("");
    const { from, to } = resetOrderDateFilter(REVOKED_ORDER_DATE_DAYS);
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
    var d = new Date();
    d.setDate(d.getDate() - 59);
    setMinValDate(d.toISOString().slice(0,10))
    
    // SL-1157
    if (globalFilter?.filter?.["orders.orderId"]){
      delete globalFilter?.filter?.["orders.orderId"];
    }
    globalFilter.filter = {
      ...globalFilter.filter,
      "from-createdAt": from + 'T00:00:00',
      "to-createdAt": to + 'T23:59:59'
    }

    // Updated to use the same API as redispatch since your data structure shows both redispatch and reverse data
    // You might need to create a separate API endpoint or modify this based on your backend
    api.order.getReverseOrder(globalFilter).then((res) => {
      // Filter data to only show items with reverseData
      /* .filter(item => 
        item.reverseData && 
        (item.reverseData.reverse)
      ); */
      const reverseOrders = res.data
      
      setdefUrl("reverse-orders-data")
      setallOrders(reverseOrders)  // Use filtered data
      setOriginalOrders(reverseOrders)  // ✅ ADD THIS

      setallRecords(reverseOrders.length)  // Use filtered count
      setennewloader("none")
    }).catch(err => {
      setennewloader("none")
      console.log(err)
    })
  }, [])

  useEffect(() => {
    if (allRecords < 1) {
      alert.info("No reverse orders found.")
    }
  }, [allRecords])

  useEffect(() => {
    if (addressName === "" || addressName === null) {
      setAddressName(undefined)
    }
  }, [addressName])

  useEffect(() => {
    if (orderId === "" || orderId === null) {
      setOrderId(undefined)
    }
  }, [orderId])

  useEffect(() => {
    if (orderName === "" || orderName === null) {
      setorderName(undefined)
    }
  }, [orderName])

  // Updated search by status for reverse orders
 function mapReverseStatus(docketStatus) {
    switch(docketStatus) {
      case "Pickup Pending":
        return "Pickup pending"; // Keep as pickup pending, not revoke
      case "Docket not live":
        return "Revoked"; // This should show as "Revoked"
      case "In transit":
      case "in transit":
        return "In transit";
      case "Delivered":
      case "delivered":
        return "Delivered";
      case "Order Placed":
        return "Pickup pending";
      case "Order placed":
        return "Pickup pending";
      default:
        return docketStatus || "Unknown";
    }
  }


//  function searchByStatus(val) {
//     let filteredOrders = [];
    
//     if (val === "allOrders") {
//       setallOrders(originalOrders);
//       setallRecords(originalOrders.length);
//       return;
//     }
    
//     filteredOrders = originalOrders.filter(item => {
//       // Prioritize package status for filtering
//       let statusToCheck = "";
      
//       // First check if there are packages with status
//       if (item.reverseData && item.reverseData.reverse && item.reverseData.reverse.pkgs && item.reverseData.reverse.pkgs.length > 0) {
//         statusToCheck = item.reverseData.reverse.pkgs[0].docketStatus;
//       }
//       // Fallback to general reverseData status if no package status
//       else if (item.reverseData && item.reverseData.status) {
//         statusToCheck = item.reverseData.status;
//       }
      
//       // Direct comparison without mapping for more reliable filtering
//       if (val === "pickupPending" && statusToCheck === "Pickup Pending") {
//         return true;
//       } else if (val === "revoked" && statusToCheck === "Docket not live") {
//         return true;
//       } else if (val === "inTransit" && (statusToCheck === "In transit" || statusToCheck === "in transit")) {
//         return true;
//       } else if (val === "delivered" && (statusToCheck === "Delivered" || statusToCheck === "delivered")) {
//         return true;
//       }
      
//       return false;
//     });
    
//     setallOrders(filteredOrders);
//     setallRecords(filteredOrders.length);
//   }

  // search by status get all value from api new changes SL-1157
  function searchByStatus (val) {
    if (val === "pickupPending") {
      globalFilter.filter = {
        ...globalFilter.filter,
        "reverseData.reverse.pkgs.docketStatus": "Order placed",
        // "orders.status": "processing"
      }
    } else if (val === "inTransit") {
      globalFilter.filter = {
        ...globalFilter.filter,
        "reverseData.reverse.pkgs.docketStatus": "In transit",
        // "orders.status": "shipped"
      }
    } else if (val === "delivered") {
      globalFilter.filter = {
        ...globalFilter.filter,
        "reverseData.reverse.pkgs.docketStatus": "Delivered",
        // "orders.status": "complete"
      }
    } else if (val === "Returned") {
      globalFilter.filter = {
        ...globalFilter.filter,
        "reverseData.reverse.pkgs.docketStatus": "Returned",
        // "orders.status": "complete"
      }
    } else {
      delete globalFilter.filter["reverseData.reverse.pkgs.docketStatus"];
      // delete globalFilter.filter["orders.status"];
    }

    api.order.getReverseOrder(globalFilter).then((res) => {
      // console.log("manual-mandava-weeder",res)
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      setennewloader("none")
    }).catch(err => {
      setennewloader("none")
      // console.log(err)
    })

    setNewReverseCount(globalFilter);
  }

  const setNewReverseCount = (filter) => {
    filter = {
      ...filter,
      "pageNo": 1,
      "size": 1,
    }
    api.order.getReverseOrder(filter).then((res) => {
      Actions.OrderCountAction(dispatch, { reverseOrder: res.totalRecords });
    })
  }

  // Rest of the functions remain the same but updated for reverse data structure
  function productPicked(id, status, pname) {
    if (status === "ASSIGN") {
      setshowToast(true)
    }
    else if (status === "DOWNLOAD") {
      setSelectedOrder(id)
      setSelectedOrdername(pname)
      setmsgConfirmation("Is product picked up by courier boy?")
      setconfirmationState(true)
    }
  }

  function isManifestDownloaded(res) {
    let outerdiv = document.getElementById("orDeskContain");
    let loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
    outerdiv.classList.add("div-bk");
    console.log(res)
    if (res === "yes") {
      // Reload the data
      api.order.getReverseOrder(globalFilter).then((res) => {
        /* filter(item => 
          item.reverseData && 
          (item.reverseData.reverse || item.reverseData.status)
        ) */
        const reverseOrders = res.data;
        setallOrders(reverseOrders)
        setallRecords(reverseOrders.length)
setOriginalOrders(reverseOrders)  // ✅ ADD THIS
        setennewloader("none")
      }).catch(err => {
        setennewloader("none")
        console.log(err)
      })
    }
  }

  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false)
    }
  }

  function responseconfirmation(response, id) {
    let data = {
      "_id": id,
      "status": "PICKED"
    }
    if (response === "yes") {
      setconfirmationState(false)
      api.order.updateOrder(data).then((res) => {
        alert.success("Order status updated")
        // Reload data
        isManifestDownloaded("yes")
      }).catch((err) => {
        console.log(err)
      })
    }
  }

  function responseConfirmNegotiate(ans, id) {
    // Same implementation as before
  }

  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }

  function setpopupVisibilitytrackWeb(e) {
    if (e) {
      setisPopupTrackVisWeb("block")
    }
    else {
      setisPopupTrackVisWeb("none")
      //SL-950
      setSelectedTransitDetail([]);
    }
  }

  function trackPopupWeb(e, trackNo, docketNo) {
    setselectedtrackOrderWeb(e)
    setselectedTrackwithin(trackNo)
  }

  // function checkevent(e, name) {
  //   if (e.keyCode === 13) {
  //     // Implement search functionality for reverse orders
  //     // Filter the existing allOrders array based on search criteria
  //     let filteredOrders = [];
      
  //     if (name === "id" && orderId !== "") {
  //       filteredOrders = allOrders.filter(item => 
  //         item.orders && item.orders.orderId && 
  //         item.orders.orderId.toLowerCase().includes(orderId.toLowerCase())
  //       );
  //     } else if (name === "name" && orderName !== "") {
  //       filteredOrders = allOrders.filter(item => {
  //         if (!item.orders || !item.orders.products) return false;
  //         return item.orders.products.some(product => {
  //           if (searchType !== 'sku') {
  //             return product.productId.productName.toLowerCase().includes(orderName.toLowerCase());
  //           } else {
  //             return product.productId.SKU.toLowerCase().includes(orderName.toLowerCase());
  //           }
  //         });
  //       });
  //     } else if (name === "address" && addressName !== "") {
  //       filteredOrders = allOrders.filter(item => {
  //         if (!item.orders || !item.orders.products) return false;
  //         return item.orders.products.some(product => 
  //           product.vendorDetails && 
  //           product.vendorDetails.addrName &&
  //           product.vendorDetails.addrName.toLowerCase().includes(addressName.toLowerCase())
  //         );
  //       });
  //     }
      
  //     if (filteredOrders.length > 0) {
  //       setallOrders(filteredOrders);
  //       setallRecords(filteredOrders.length);
  //     }
  //   }
  // }

  // get filtered data from api by sending filtered query SL-1157
  function checkevent(e, name, selectedAddress = null) {//SL-923
    // setHistsortdatefrom("")
    // setHistsortdateto("")
    if (e.keyCode === 13) {
      let outerdiv = document.getElementById("orDeskContain");
      let loaderDiv = document.getElementById("enNewLoader");

      if (name === "id" && orderId !== "") {
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
        globalFilter.pageNo = 1
        globalFilter.filter = {
          ...globalFilter.filter,
          "orders.orderId": orderId
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order.getReverseOrder(globalFilter).then((res) => {
          console.log(res)
          setallOrders(res.data)
          setallRecords(res.data.length);
          loaderDiv.classList.remove("loader-bt");
          outerdiv.classList.remove("div-bk");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
      else if (name === "name" && orderName !== "") {
        setSelectedPage(1)
        let ordersearchFilter=searchType!='sku'?{"orders.products.productId.productName": orderName}:{"orders.products.productId.SKU": orderName};
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk")
        setcompforPaginationweb("webFilt")
        globalFilter.pageNo = 1
        globalFilter.filter = {
            ...globalFilter.filter,   
          ...ordersearchFilter
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order.getReverseOrder(globalFilter).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("name");
          loaderDiv.classList.remove("loader-bt");
          outerdiv.classList.remove("div-bk");
          setennewloader("none")
        }).catch(err => console.log(err));

      }
      else if (name === "address" /*&& addressName !== ""*/) {//SL-923
        setSelectedPage(1)
        setcompforPaginationweb("allOrdersWeb")
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
        globalFilter.pageNo = 1;
        globalFilter.filter = {
          ...globalFilter.filter,
          "orders.products.vendorDetails.addrName":  selectedAddress //addressName // SL-923
        }
        api.order.getReverseOrder(globalFilter).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          outerdiv.classList.remove("div-bk");
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err));
      }

      setNewReverseCount(globalFilter);
    }
  }

  function detail(data, price) {
    setdetailPPrice(price)
    if (data && data[0] === undefined) {
      setproductDetail([{
        "description": "No details available",
        "sdescription": "No short description",
        "name": undefined,
        "price": undefined,
        "SKU": undefined,
        "popupVisibility": undefined,
        "images": []
      }])
    } else {
      setproductDetail(data)
    }
  }

  function paginate(data) {
    // For now, since we're filtering locally, we'll just reset to original data
    // In a real implementation, you'd want to implement server-side pagination
    setSelectedPage(data.number)
  }

  function setdateweb(e, type) {
    const { from, to } = resolveOrderDateRange(type, e.target.value, dateFromWeb, dateToWeb);
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
  }

  function applyFilter() {
    // Apply date filter and reload data
    if (dateFromWeb === undefined || dateToWeb === undefined || dateFromWeb === "" || dateToWeb === "") {
      showOrderDateAlert("please select both date", "show");
      return false;
    }

    let fromDate = new Date(dateFromWeb)
    let toDate = new Date(dateToWeb);
    let diffDate = toDate.getTime() - fromDate.getTime()
    let daydiffer = diffDate / (1000 * 60 * 60 * 24);
    daydiffer = Math.floor(daydiffer)
    if(daydiffer > 60){
        showOrderDateAlert("Date range cannot be more than 60 days.")
        return 0;
    }
    
    globalFilter.filter = {
      ...globalFilter.filter,
      "from-createdAt": dateFromWeb + 'T00:00:00',
      "to-createdAt": dateToWeb + 'T23:59:59'
    }
    
    api.order.getReverseOrder(globalFilter).then((res) => {
      const reverseOrders = res.data.filter(item => 
        item.reverseData && 
        (item.reverseData.reverse || item.reverseData.status)
      );
      setallOrders(reverseOrders)
      setallRecords(reverseOrders.length)
    }).catch(err => {
      console.log(err)
    })
  }

  // Close popups on escape key
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key === "Esc" || evt.key === "Escape") {
      setconfirmationState(false)
      setisPopupTrackVisWeb("none")
      setisDetailPopupVis("none")
    }
  };

  // const filterSearch = (data) => {
  //   setorderName(data.data);
  //   setSearchType(data.type)
  // }

    // get orders by product name and sku
  const filterSearch=(data)=>{
    // setorderName(data.data);
    // setSearchType(data.type)
    applyLoader();
    globalFilter['filter'] = { ...globalFilter.filter, "orders.products.productId._id-Id": data.data }
   
    globalFilter.pageNo = 1;
    setSelectedPage(1)
    getOrders();
  }

  const ApiCalling = (flag) => {
    applyLoader()
    globalFilter.pageNo = selectedPage;
    if (flag === "reset") {
      delete globalFilter?.filter?.["orders.products.productId._id-Id"];
      globalFilter.pageNo = 1;
      setSelectedPage(1)
    }
    getOrders();
  }

  /**
   * Search By Keyword On Enter
   */
  const searchByKeyword = (value, type, productIds) => {

    if (productIds.length > 0) {
      applyLoader()
      if (type === "sku") {
        globalFilter['filter'] = { ...globalFilter.filter, "orders.products.productId._id-Id": productIds?.[0] }
        
      }
      else {
        globalFilter['filter'] = { ...globalFilter.filter, "orders.products.productId._id-Id": {$in: productIds} }
      }
      //Search Issue on Other than 1st Page SL-698 and SL-675
      globalFilter.pageNo = 1;
      setSelectedPage(1);
      getOrders();
    }
    else {
      setallOrders([]);
      setallRecords(0);

    }
  }

  const getOrders = () => {
    try {
      applyLoader()
      api.order.getRedispatchOrder(globalFilter).then((res) => {
        removeLoader()
        setdefUrl("manual-mandava-weeder")
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        throw new Error(err)
      })
    } catch (err) {
      removeLoader()
      console.log(err)
    }
  }

  function applyLoader() {
    outerdiv = document.getElementById("orDeskContain");
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
    outerdiv.classList.add("div-bk");
  }

  // remove loader
  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setennewloader("none")
    outerdiv.classList.remove("div-bk");
  }

  useEffect(() => {
    if (orderName !== "" && orderName !== null && orderName !== undefined) {
      checkevent({ "keyCode": 13 }, "name");
    }
  }, [orderName])

  return (
    <>
      <div className="" id="orDeskContain">
        <div class="tab">
          <div className='d-flex mb-3 justify-content-start'>
            <div className='theme-shed1 p-2'>
              <div className='m-auto mt-1'>
                <span className='payment_dates'>From: - 
                  <input 
                    type='date' 
                    max={sortHistdateto || undefined}
                    value={sortHistdatefrom} 
                    onChange={(e) => setdateweb(e, "from")}
                  />
                </span>
                <span className='mx-2 payment_dates'>To: - 
                  <input 
                    type='date'
                    min={sortHistdatefrom || undefined}
                    max={moment().format('YYYY-MM-DD')}
                    value={sortHistdateto} 
                    onChange={(e) => setdateweb(e, "to")}
                  />
                </span>
                <span>
                  <button 
                    className='apply-btn px-3 py-1 ff_Pop fs-14' 
                    onClick={() => applyFilter()}
                  >
                    Apply
                  </button>
                </span>
              </div>
            </div>
          </div>
          
          <div className="table-responsive">
            <table className='ord_table new-table-design' style={{ "width": "100%" }}>
              <thead>
                <tr className='table_ord_title_row'>
                  <th className='thead_title' style={{ "width": "10%" }}>
                    Order ID<br/>
                    <input 
                      type="text" 
                      value={orderId || ''} 
                      placeholder='Search' 
                      className='w-90 order_table_srch_input' 
                      onChange={(e) => setOrderId(e.target.value)} 
                      onKeyUp={(e) => checkevent(e, "id")} 
                    />
                    <i 
                      class="fa fa-search pointer search-space order_table_srch_input_icon" 
                      aria-hidden="true" 
                      onClick={() => checkevent({ "keyCode": 13 }, "id")}
                    />
                  </th>
                  
                  <th className='thead_title pb-1' style={{ "width": "12%" }}>
                    Issue Reported On
                  </th>
                  
                  <th className='thead_title' style={{ "width": "10%" }}>
                    Product image
                  </th>
                  
                  <th className='thead_title' style={{ "width": "20%" }}>
                    Product Name & SKU
                    <br/>
                    <OrderSKUSearch
                      filterSearch={filterSearch}
                      searchNewEnq={setorderName}
                      from={"orders"}
                      flag="Order" // set flag
                      apiCall={ApiCalling}
                      data="filedData"
                      // totalRcordId={totalRcordId}
                      searchByKeyword={searchByKeyword}
                      apiurl="searchSellerOrdersFilter"
                      ordersSearchParam={globalFilter}
                    />
                  </th>
                  
                  <th className='thead_title' style={{ "width": "7%" }}>
                    Transfer price
                  </th>
                  
                  {/* <th className='thead_title' style={{ "width": "10%" }}>
                    Pickup Address<br/>
                    <input 
                      type="text" 
                      value={addressName || ''} 
                      placeholder='Search..' 
                      className='w-95 order_table_srch_input' 
                      onChange={(e) => setAddressName(e.target.value)} 
                      onKeyUp={(e) => checkevent(e, "address")} 
                    />
                    <i 
                      className="fa fa-search pointer search-space order_table_srch_input_icon" 
                      aria-hidden="true" 
                      onClick={() => checkevent({ "keyCode": 13 }, "address")}
                    />
                  </th> */}
                  
                  <th className='thead_title' style={{ "width": "5%" }}>
                    Total package
                  </th>
                  
                  <th className='thead_title' style={{ "width": "19%" }}>
                    Status <br/>
                    <select onChange={(e) => searchByStatus(e.target.value)}>
                      <option value="allOrders">All orders</option>
                      <option value="pickupPending">Pickup pending</option>
                      {/* <option value="revoked">Revoked</option> */}
                      <option value="inTransit">In transit</option>
                      {/* <option value="delivered">Delivered</option> */}
                      <option value="Returned">Returned</option>
                    </select>
                  </th>
                </tr>
              </thead>
              
              <tbody>
                {allOrders?.length > 0 ? allOrders.map((item1, index) => {
                  // Enhanced status mapping for reverse orders
                 // Enhanced status mapping for reverse orders
        let reverseStatus = "Unknown";
        
        if (item1.reverseData && item1.reverseData.reverse && item1.reverseData.reverse.pkgs && item1.reverseData.reverse.pkgs.length > 0) {
          const docketStatus = item1.reverseData.reverse.pkgs[0].docketStatus;
          reverseStatus = mapReverseStatus(docketStatus); // Use the helper function
        } else if (item1.reverseData && item1.reverseData.status) {
          reverseStatus = mapReverseStatus(item1.reverseData.status);
        }

        item1['reverseStatus'] = reverseStatus;

                  // Get order data
                  let item = {};
                  item['order'] = item1.orders;
                  
                  // Handle date formatting
                  let update = new Date(item1.createdAt);
                  let upd = update.toUTCString();
                  let upnewd = upd.substr(4, 12);

                  let delivDate = new Date(item.order?.updatedAt)
                  let delDate = delivDate.toUTCString()
                  let newDelDate = delDate.substr(4, 12)

                  // Handle base image
                  let baseImg = "";
                  if (item.order && item.order.products && item.order.products.length > 0) {
                    const product = item.order.products[0];
                    if (product.productId && product.productId.images) {
                      const baseImage = product.productId.images.find(img => img.baseImage === true);
                      if (baseImage) {
                        if (baseImage.image.startsWith("products")) {
                          baseImg = baseImage.image ? baseImage.image : '';
                        } else {
                          baseImg = `${baseImage.image}`;
                        }
                      }
                    }
                  }

                  if (item.order && item.order.products && item.order.products.length > 0) {
                    const product = item.order.products[0];
                    
                    return (
                      <OrderCardWeb 
                        key={item._id}
                        id={index}
                        type="reverse"
                        createddAt={upnewd}
                        lead={item.order._id}
                        fullObj={item1}
                        nicknameAdd={product.vendorDetails?.addrName}
                        taxClass={product.productId.taxClass}
                        sku={product.productId.SKU}
                        date={upnewd}
                        actualdate={item1.createdAt}
                        orderId={item.order.orderId}
                        url={product.productId.urlKey}
                        productName={product.productId.productName}
                        price={product.purchase_price}
                        quantity={product.quantity}
                        status={'reverse'}
                        invoices={item1.reverseData?.reverse?.pkgs || []}
                        isProductPickedFun={productPicked}
                        image={baseImg}
                        popupdetailVis={setpopupVisibilityDetail}
                        popupVisibility={setpopupVisibilitytrackWeb}
                        selSubPrdVal={product.selSubPrd?.value}
                        pdetail={detail}
                        vendor={item1.vendor}
                        revokes={product.revokes}
                        combination={product.productId.combination?.[0]?.value}
                        isManifestDownloadedFun={isManifestDownloaded}
                        pkgs={item1.reverseData?.reverse?.pkgs || []}
                        revokeReason={item1.revoke}
                        fun={trackPopupWeb}
                        orderForwardedToSeller={false}
                        orderMainId={item.order._id}
                        docketNotGenerated={item.order?.docketNotGenerated}
                        reverseStatus={reverseStatus}
                        deliveredOn={newDelDate}
                        platformFee={item.order?.pfFees}
                        showTrackButton={reverseStatus !== "Revoke"} // Add this prop
                        //SL-950
                        onTransitFetched={(_id,detail, orderId, trackNo) => {
                          setSelectedPopupId(_id);
                          setSelectedTransitDetail(detail);
                          setselectedtrackOrderWeb(orderId);
                          setselectedTrackwithin(trackNo);
                          setpopupVisibilitytrackWeb(true)
                        }}
                      />
                    )
                  } else {
                    return (
                      <OrderCardWeb 
                        key={item._id}
                        id={index}
                        type="Reverse-Orders"
                        lead={item1._id}
                        orderId={item.order?.orderId || "N/A"}
                        status="noprodetail"
                        reverseStatus={reverseStatus}
                        showTrackButton={reverseStatus !== "Revoke"} 
                      />
                    )
                  }
                }) : (
                  <tr>
                    <td colSpan="8" className="text-center">No reverse orders found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center" id="enNewLoader">
            <div style={{ "display": ennewloader }}>
              <MainLoader/>
            </div>
          </div>

          <PaginationCom
            number={allRecords}
            activ={selectedPage}
            paginate={paginate}
            comp={compforPaginationweb}
          />
        </div>

        {/* Toast */}
        <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
          <Toast.Header>
            <strong className="me-auto">Message</strong>
          </Toast.Header>
          <Toast.Body>Download manifest to proceed with pickup.</Toast.Body>
        </Toast>

        {/* Modal Confirmation */}
        <Modal
          show={confirmationState}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <ConfirmationModal
            onHide={confirmationBoxHiding}
            selectedId={selectedOrder}
            msg={msgConfirmation}
            responseconfirmationFun={responseconfirmation}
          />
        </Modal>

        {/* Track detail for web | Ticket : SL-950 */}
        {isPopupTrackVisWeb == 'block' && 
        <div id="popupTrackweb" className={`overlay ${isPopupTrackVisWeb == 'block' ? 'visible' : ''}`} style={{ "display": "block" }}>
            <TrackOrderPopup
              type="New-Orders"
              id={selectedPopupId}
              trackDetail={selectedTransitDetail}
              popupVisibility={setpopupVisibilitytrackWeb}
            /> 
        </div>}

        <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
          <Popup
            from="reverseOrder"
            description={productDetail[0]?.description}
            sdescription={productDetail[0]?.shortDescription}
            descriptionNew={productDetail[0]?.descriptionNew}
            specificationNew={productDetail[0]?.specificationNew}
            name={productDetail[0]?.productName}
            price={detailPPrice}
            SKU={productDetail[0]?.SKU}
            popupVisibility={setpopupVisibilityDetail}
            images={productDetail[0]?.images}
            videos={productDetail[0]?.videos}
          />
        </div>
      </div>
    </>
  )
}

export default ReverseOrders;